import { render } from "./Interruption.vue?vue&type=template&id=47d57610"
import script from "./Interruption.vue?vue&type=script&lang=js"
export * from "./Interruption.vue?vue&type=script&lang=js"

import "./Interruption.vue?vue&type=style&index=0&id=47d57610&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/quiz/components/Interruption.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47d57610"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47d57610', __exports__)) {
    api.reload('47d57610', __exports__)
  }
  
  module.hot.accept("./Interruption.vue?vue&type=template&id=47d57610", () => {
    api.rerender('47d57610', render)
  })

}


export default __exports__